import { render, staticRenderFns } from "./tianLing.vue?vue&type=template&id=f40e74d8&scoped=true"
import script from "./tianLing.vue?vue&type=script&lang=js"
export * from "./tianLing.vue?vue&type=script&lang=js"
import style0 from "./tianLing.vue?vue&type=style&index=0&id=f40e74d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40e74d8",
  null
  
)

export default component.exports